type ColorType =
  | "BrandLavender"
  | "BrandPeach"
  | "UiPrimaryStronger"
  | "StatusSuccess";

const COLORS: ColorType[] = [
  "BrandLavender",
  "BrandPeach",
  "UiPrimaryStronger",
  "StatusSuccess",
];

export function generateActorColor(label: string): ColorType {
  let hash = 0;

  for (let i = 0; i < label.length; i++) {
    hash = (31 * hash + label.charCodeAt(i)) | 0; // Simple hash function
  }

  const index = Math.abs(hash) % COLORS.length;
  return COLORS[index];
}
